exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".label-part-param{border:#ea705a 1px solid}.label-part-param .card{padding:10px}.part-img{max-height:200px}", ""]);

